import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import PropTypes from "prop-types";

const Pagination = ({
  currentOffset,
  endOffset,
  pageNumber,
  hasPreviousPage,
  hasNextPage,
  onPageChange,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        mr: 2,
        gap: 1,
        mt: 2,
        px: 2,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          minWidth: "80px",
          fontWeight: 500,
        }}
      >
        Showing {currentOffset + 1}-{endOffset}
      </Typography>

      <IconButton
        onClick={() => onPageChange("PREVIOUS", pageNumber - 1)}
        disabled={!hasPreviousPage || pageNumber === 1}
        size="small"
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        }}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "32px",
          height: "32px",
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "4px",
          backgroundColor: theme.palette.action.hover,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {pageNumber}
        </Typography>
      </Box>

      <IconButton
        onClick={() => onPageChange("NEXT", pageNumber + 1)}
        disabled={!hasNextPage}
        size="small"
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        }}
      >
        <ChevronRight fontSize="small" />
      </IconButton>
    </Box>
  );
};

Pagination.propTypes = {
  currentOffset: PropTypes.number.isRequired,
  endOffset: PropTypes.number.isRequired,
  pageNumber: PropTypes.number.isRequired,
  hasPreviousPage: PropTypes.bool.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
